import React from 'react';


const HomeBut = props => {
  return(
    <>
<svg style={{ fill: props.color, stroke:props.color}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 89"><path d="M95.8 35.3L78.3 22.7V9.9a4 4 0 00-8 0v6.9L52.4 4a4.06 4.06 0 00-4.7 0L4.2 35.3a4.12 4.12 0 00-.9 5.7 4 4 0 005.6.9l5.3-3.8v38.7a4 4 0 004 4h63.5a4 4 0 004-4V38l5.3 3.8a4 4 0 005.7-.9 4 4 0 00-.9-5.6zm-40 37.4H44.2V50.4h11.5v22.3zm21.9 0H63.8V46.3a4 4 0 00-4-4H40.2a4 4 0 00-4 4v26.4H22.3V32.2l27.7-20 27.7 20z"/></svg></>
  )


}

export default HomeBut;
